<template>
  <div :class="$style.newsArchivePage">
    <app-layout :render-left-column="false">
      <template slot="central-column">
        <div :class="$style.wrap">
          <div :class="$style.blockHeader">
            <jtn-ui-typography
              :class="$style.pageHeader"
              tag="h1"
              type="font-vijet-title"
            >
              {{ pageHeader }}
            </jtn-ui-typography>
            <jtn-ui-typography
              v-if="themeDescription"
              :class="$style.themeDescription"
              tag="p"
              type="font-second-news-txt"
            >
              {{ themeDescription }}
            </jtn-ui-typography>
            <jtn-ui-btn
              v-if="telegramBtnData !== null"
              v-observe-visibility="telegramBtnVisibility$.getOptions('half')"
              :class="$style.tgBtn"
              :href="telegramBtnData.link"
              target="_blank"
              theme="white"
              @click="sendRGForClickedTgBtn"
            >
              <template #left>
                <svg width="24" height="24">
                  <use xlink:href="jtn-social-telegram"></use>
                </svg>
              </template>
              {{ telegramBtnData.title }}
              <template #right>
                <svg width="24" height="24">
                  <use xlink:href="jtn-critical-arrow-line-right"></use>
                </svg>
              </template>
            </jtn-ui-btn>
          </div>
          <archive-filter v-if="hasFilter" :date="date" @submitFilter="onFilter" />
          <search-records-list
            v-if="showedResults"
            page-type="theme"
            :records="newsData"
            :hasTheme="false"
          />
          <jtn-ui-typography
            v-else
            :class="$style.notice"
            tag="div"
            type="font-photoday-type-1"
          >
            {{ noticeMessage }}
          </jtn-ui-typography>
          <jtn-ui-pagination
            v-model="pageData"
            v-if="showedResults"
            v-show="pageData.numPages && pageData.numPages > 1"
            :class="$style.pagination"
            :items-per-page="params.pagesize"
            :total-items="totalResult"
            @change="changePage(pageData.currentPage)"
          />
        </div>
      </template>

      <template slot="right-column">
        <app-right-column />
      </template>
    </app-layout>
  </div>
</template>

<script>
import { JtnUiBtn } from '@jtnews/jtn-ui';
import { ObserverVisibility } from '@jtnews/shared';
import AppLayout from '../../../layout/containers/app-layout';
import AppRightColumn from '../../../layout/containers/app-right-column';
import { ArchiveFilter } from '../components/archive-filter';

import { PageAnalyticsMixin } from '../../../shared/mixins/page-analytics';
import { WindowScrollMixin } from '../../../shared/mixins/window-scroll.mixin';
import { CoreSearchLogicMixin } from '../../../shared/mixins/core-search-logic.mixin';

import { getDateRange } from '../../../shared/utils/';

export default {
  name: 'ThemePage',
  components: {
    AppLayout,
    AppRightColumn,
    ArchiveFilter,
    JtnUiBtn
  },
  mixins: [WindowScrollMixin, CoreSearchLogicMixin, PageAnalyticsMixin],
  data() {
    return {
      hasFilter: this.$route.params.year === undefined,
      telegramBtnVisibility$: new ObserverVisibility('half')
    };
  },
  computed: {
    pageHeader() {
      return this.themeName;
    },
    themeParams() {
      return this.themeBlock?.data || null;
    },
    themeName() {
      return this.themeParams?.name || 'Неизвестная тема!';
    },
    themeDescription() {
      return this.themeParams?.description || '';
    },
    telegramBtnData() {
      return this.store?.archivesModule.telegramBtn?.data || null;
    }
  },
  beforeMount() {
    this.params.themeId = this.$route.params.themeId;

    if (!this.hasFilter) {
      const { year, month, day } = this.$route;
      const { dateFrom, dateTo } = getDateRange(year, month, day);

      this.params = {
        ...this.params,
        dateFrom,
        dateTo
      };
    }

    if (this.telegramBtnData !== null) {
      this.telegramBtnVisibility$.event.subscribe(state => {
        if (state.value) {
          this.sendRGForViewTgBtn();
        }
      });
    }
  },
  beforeDestroy() {
    if (this.telegramBtnData !== null) {
      this.telegramBtnVisibility$.destroy();
    }
  },
  methods: {
    sendRGForViewTgBtn() {
      const goalName = 'SubscriptionInsertView';
      const blockType = 'Врезка подписки';
      const value = {
        ['Просмотр']: {
          [this.params.themeId]: 'Спецоперация на Украине'
        }
      };

      this.sendNewReachGoal(blockType, value, goalName)
      this.sendNewFormatReachGoal({
        blockType,
        goalName,
        actionType: 'Просмотр',
        prop1: this.params.themeId,
        prop2: 'Спецоперация на Украине'
      });
    },
    sendRGForClickedTgBtn() {
      const goalName = 'SubscriptionInsertClickTG';
      const blockType = 'Врезка подписки';
      const value = {
        ['Клик']: {
          [this.params.themeId]: 'Спецоперация на Украине (TG)'
        }
      };

      this.sendNewReachGoal(blockType, value, goalName)
      this.sendNewFormatReachGoal({
        blockType,
        goalName,
        actionType: 'Клик',
        prop1: this.params.themeId,
        prop2: 'Спецоперация на Украине (TG)'
      });
    },
    sendNewReachGoal(fieldType, valueName, goalName) {
      const blockType = 'Центральная колонка';

      this.store.analyticsModule.sendNewReachGoal({
        blockType,
        fieldType,
        valueName,
        goalName,
        willDeprecate: true
      });
    },
    sendNewFormatReachGoal({ blockType, goalName, actionType, prop1, prop2 }) {
      this.store.analyticsModule.sendNewFormatReachGoal({
        blockType,
        goalName,
        actionType,
        prop1,
        prop2
      });
    },
  }
};
</script>

<style lang="scss" module>
@import 'styles';
@import '../../../styles/news-archive-page';

.blockHeader {
  display: flex;
  flex-wrap: wrap;
  padding: 0 0 16px;
  margin: 0 12px;

  @include on-min-resize($tablet) {
    margin: 0 20px;
  }

  @include on-min-resize($laptop) {
    margin-bottom: 16px;
    border-bottom: 1px solid $color-surface-100;
  }

  .tgBtn {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
    padding: 11px;
    margin: 16px 0 6px;
    line-height: 12px;

    @include on-min-resize($laptop) {
      width: 268px;
      margin: 0 0 14px 20px;
    }
  }
}

.pageHeader {
  width: 100%;
  margin-bottom: 12px;
}

.themeDescription {
  @include on-min-resize($laptop) {
    flex: 1 0 0;
  }
}

</style>
